<main class="file-upload-container">
  @if (!loadPage) {
    <lbca-loading></lbca-loading>
  }

  @if (!configuration.maxFiles) {
    <main
      class="file-upload-structure"
      [class.h-[480px]]="readonly && table.body.length === 0 && loadPage"
    >
      @if (loadPage) {
        @if (remainingFileCount) {
          <div class="mb-[15px]">
            <lbca-message-field
              [label]="
                'A plataforma Consumidor.gov permite o envio de até 5 arquivos por reclamação. Se esse limite for excedido, os arquivos não serão mais integrados na plataforma do Consumidor.gov.'
              "
              [color]="'warning'"
            ></lbca-message-field>
          </div>
        }
        @if (!isDisabled && !readonly && !configuration.validator) {
          <div
            class="file-upload-container-droppable"
            [style.height.px]="remainingFileCount ? 160 : 140"
            lbcaFileUpload
            [class.error]="hasErrorRequerid"
            [class.loading]="uploading"
            (fileDropped)="onFileDrop($event)"
          >
            <span class="upload mt-[15px]">
              <span class="contorno">
                <div class="ico-file-upload"></div>
                <div class="flex dragndrop-area">
                  <span class="text-base mr-[10px]">
                    Arraste e solte seus documentos aqui ou clique em
                  </span>
                  <div class="flex">
                    <input
                      #inputRefFiles
                      class="hidden"
                      [id]="'file' + idFile"
                      type="file"
                      value="Anexar arquivo"
                      multiple
                      (change)="uploadTreatment($event)"
                    />
                    <button
                      (mouseenter)="showErrorRequerid()"
                      (mouseleave)="removeErrorRequerid()"
                      type="button"
                      id="file-upload-button-anexo"
                      class="btn-primary btn-type-2 z-[900] button-anexo"
                    >
                      <label [for]="'file' + idFile">Anexar arquivo</label>
                    </button>
                  </div>
                </div>
              </span>
            </span>
            @if (remainingFileCount) {
              <p class="text-base mt-[10px] text-center">
                Quantidade de arquivos restantes para integração: {{ count }}
              </p>
            }
          </div>
        }
        @if (tableRestore.length > 0) {
          <div #tableRef class="file-upload-table-container mb-[30px] mt-[48px]">
            <lbca-table-file
              class="file-upload-table"
              [table]="table"
              [removeLine]="lineremove"
              [rightDeslocation]="line"
              [lineCickable]="false"
              [bodyLength]="updateBody"
              (changeValue)="setLaneValue($event)"
              [cardData]="cardInfo"
              (order)="orderTable($event)"
            ></lbca-table-file>
          </div>
        }
        @if (isDisabled && table.body.length === 0) {
          <lbca-body-feedback feedbackIcon="noFiles" type="files">
            <ng-container filesMessagePrimary>
              Nenhum arquivo para
              <br />
              visualizar
            </ng-container>
          </lbca-body-feedback>
        }
      }
    </main>
  }

  @if (configuration.maxFiles) {
    <main class="single-file-upload-structure">
      @if (!condensed) {
        <div class="inline-flex items-center mb-[12px] ng-star-inserted">
          <p class="text-font text-xs">{{ labelValue }}</p>
        </div>
      }
      @if (loadPage) {
        @if (!isDisabled && !readonly && !condensed && filesList.length === 0) {
          <div
            class="file-upload-container-droppable"
            lbcaFileUpload
            [class.error]="hasErrorRequerid"
            [class.loading]="uploading"
            (fileDropped)="onFileDrop($event)"
          >
            <span class="upload">
              <span class="contorno">
                <div class="flex dragndrop-area items-center">
                  <div class="ico-file-upload mt-[20px]"></div>
                  <span class="text-base mr-[10px] ml-[10px]">
                    Arraste e solte seus documentos aqui ou clique em
                  </span>
                  <div class="flex">
                    <input
                      class="hidden"
                      [id]="'file' + idFile"
                      type="file"
                      value="Anexar arquivo"
                      multiple
                      (change)="uploadTreatment($event)"
                    />
                    <button
                      (mouseenter)="showErrorRequerid()"
                      (mouseleave)="removeErrorRequerid()"
                      type="button"
                      id="file-upload-button-anexo"
                      class="btn-primary btn-type-2 z-[900] button-anexo"
                    >
                      <label [for]="'file' + idFile">Anexar arquivo</label>
                    </button>
                  </div>
                </div>
              </span>
            </span>
          </div>
        }
        @if (filesList.length > 0) {
          <div>
            @for (file of filesList; track file) {
              @if (!file.editLabel) {
                <div class="progress-container" [class.justify-end]="file.motionCompleteDataSend">
                  <div
                    class="progress-bar upload-bar"
                    [class.progress-loaded]="file.motionCompleteDataSend"
                    [style.width.%]="file.progress"
                  ></div>
                </div>
              }
              @if (file.editLabel) {
                <div class="inline-flex items-center">
                  <div class="file-actions-container" [class.pr-[20px]]="file.remove">
                    @if (!condensed) {
                      <label class="file-delete" (click)="confirmDelete(file)">
                        @if (file.remove) {
                          <div class="iconrenderer trash bg-gray-600"></div>
                        }
                      </label>
                    }
                  </div>
                  @if (condensed) {
                    <span class="text-xs text-gray-600 mr-[15px] whitespace-nowrap">
                      {{ labelValue }}
                    </span>
                  }
                  <img
                    src="{{ file.icon }}"
                    class="cursor-pointer"
                    (click)="getUpload(file.origin, file.bucket, file.key, file.fileName)"
                  />
                  <span
                    class="no-select text ml-[6px] cursor-pointer text"
                    [ngClass]="{
                      'text-xs text-gray-600': condensed,
                      'text-font text-xs': !condensed,
                    }"
                    (click)="getUpload(file.origin, file.bucket, file.key, file.fileName)"
                  >
                    {{ file.fileName }}
                  </span>
                  @if (!condensed && !isDisabled) {
                    <div class="file-actions-container pr-[20px]">
                      <label class="file-delete" (click)="deleteItem($event, file)">
                        @if (!file.remove) {
                          <div class="iconrenderer trash bg-gray-600"></div>
                        }
                        @if (file.remove) {
                          <div class="iconrenderer error bg-gray-600"></div>
                        }
                      </label>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      }
    </main>
  }
</main>

<ng-template #icon let-file>
  <div class="flex items-center w-full min-h-[40px] bg-gray-50">
    <img src="{{ file.icon }}" />
  </div>
</ng-template>

<ng-template #name let-file>
  <div class="flex items-center w-full min-h-[40px] bg-white">
    <img src="{{ file.icon }}" />
    <span class="no-select text text-xs ml-[12px]">{{ file.fileName }}</span>
  </div>
</ng-template>

<ng-template #documentType let-file>
  <div
    class="flex w-full items-center min-h-[40px] bg-white"
    [id]="'fileTypeUser-' + file.id"
    (mouseenter)="showError($event, file, 'fileTypeUser-' + file.id)"
    (mouseleave)="removeError()"
  >
    @if (file.progress !== null) {
      <div class="flex justify-center items-center gap-2 w-full">
        <lbca-icon name="svg-spinners:ring-resize" color="primary" [size]="16" />
        <span class="text-xs text-primary-500">carregando...</span>
      </div>
    } @else {
      <lbca-select-rounded
        class="w-full"
        [data]="file"
        [showErrorPopup]="false"
        [error]="file.error ? file.error : null"
        [label]="'Qual o tipo de documento?'"
        [options]="listfiletype"
        [require]="true"
        [loadingState]="file.savingType"
        [readonly]="readonly || configuration.validator"
        [disabled]="isDisabled"
        [dataSave]="pullSave"
        (tryActionAgain)="tryAgain($event, file)"
        (saveEnable)="enableSave($event, file)"
        [labeled]="file.documentType ? false : true"
        (changeValue)="changeValue($event, file, 'documentType')"
        (errorState)="changeState(file.id, 'error', $event)"
        (validState)="changeState(file.id, 'valid', $event)"
        [value]="file.documentType"
      ></lbca-select-rounded>
    }
  </div>
</ng-template>

<ng-template #actionsRender let-file>
  <div class="file-actions-container">
    @if (!file.remove) {
      <lbca-button
        [disabled]="file.progress !== null"
        (click)="deleteItem($event, file)"
        variant="unstyled"
        size="small"
        icon
        title="Excluir"
      >
        <lbca-icon name="lucide:trash-2" />
      </lbca-button>
    }
    @if (file.remove) {
      <lbca-button variant="unstyled" icon title="Fechar">
        <lbca-icon name="lucide:x" />
      </lbca-button>
    }
  </div>
</ng-template>

<ng-template #countItens let-file>
  <span class="text text-xs">{{ file.index }}</span>
</ng-template>

<ng-template #baixar let-file>
  <lbca-button
    [class.hidden]="!file.editLabel"
    (click)="getUpload(file.origin, file.bucket, file.key, file.fileNameHash)"
    variant="unstyled"
    icon
    size="small"
  >
    <lbca-icon name="lucide:download" />
  </lbca-button>
</ng-template>

<ng-template #templateBaixando>
  <div class="text-base text-font flex items-center justify-center show">
    Baixando...
    <div class="emojis-folder icon-box ml-[16px]"></div>
  </div>
</ng-template>

<ng-template #templateRemove>
  <div class="text-base text-font flex items-center justify-center show">
    Arquivo excluído!
    <div class="emojis-wastebasket icon-box ml-[16px]"></div>
  </div>
</ng-template>

<ng-template #templateRemoveError>
  <div class="text-base text-font flex items-center justify-center show">
    Erro ao tentar excluir o arquivo!
    <div class="emojis-wastebasket icon-box ml-[16px]"></div>
  </div>
</ng-template>

<ng-template #templateMaxSizeError>
  <div class="text-base text-font flex items-center justify-center show">
    O arquivo selecionado excede o tamanho máximo permitido (1MB). Por favor, selecione um arquivo
    menor.
    <div class="emojis-wastebasket icon-box ml-[16px]"></div>
  </div>
</ng-template>

<ng-template #templateInvalidExtensionError>
  <div class="text-base text-font flex items-center justify-center show">
    O formato do arquivo enviado não é aceito. Favor usar um dos seguintes formatos: doc, docx, gif,
    jpeg, jpg, ods, odt, pdf, png, txt, xls ou xlsx.
    <div class="emojis-wastebasket icon-box ml-[16px]"></div>
  </div>
</ng-template>

<ng-template #sizeFeedback let-file>
  <span class="text text-xs">{{ formatBytes(file.size) }}</span>
</ng-template>

<ng-template #documentTypeAction let-file>
  @if (!readonly) {
    <a
      class="docTypeAction"
      [class.active]="actionSaveAll"
      [class.inactive]="!actionSaveAll"
      (click)="salveAll($event)"
    >
      Salvar todos
    </a>
  }
</ng-template>

<ng-template #radioButtonVizualizacao let-file>
  <div class="flex w-full mt-[7px] bg-gray-50 items-center justify-start">
    <lbca-input-radio
      [disabled]="file.editLabel === false"
      [inline]="true"
      [dangerNegativeOpt]="true"
      [value]="file.clientView"
      [options]="[
        { id: true, label: 'Sim' },
        { id: false, label: 'Não' },
      ]"
      (changeValue)="changeValue($event, file, 'clientView')"
    ></lbca-input-radio>
  </div>
</ng-template>

<ng-template #radioButtonDuplication let-file>
  <div class="flex w-full mt-[7px] bg-gray-50 items-center justify-start">
    <lbca-input-radio
      [disabled]="file.editLabel === false"
      [inline]="true"
      [dangerNegativeOpt]="true"
      [value]="file.duplicateFile"
      [options]="[
        { id: true, label: 'Sim' },
        { id: false, label: 'Não' },
      ]"
      (changeValue)="duplicateFileForProcess($event, file)"
    ></lbca-input-radio>
  </div>
</ng-template>

<ng-template #radioButtonValidado let-file>
  <div class="flex w-full mt-[7px] bg-gray-50 items-center justify-start">
    <lbca-input-radio
      [disabled]="file.editLabel === false"
      [inline]="true"
      [dangerNegativeOpt]="true"
      [value]="file.validated"
      [options]="[
        { id: true, label: 'Validado' },
        { id: false, label: 'Incorreto' },
      ]"
      (changeValue)="changeValue($event, file, 'validated')"
    ></lbca-input-radio>
  </div>
</ng-template>

<ng-template #checkboxSelectLine let-file>
  <div
    [class.show]="file.editLabel"
    [class.opacity-40]="!file.editLabel"
    class="flex w-full mt-[7px] bg-gray-50 items-center justify-start"
  >
    <lbca-input-boolean
      [disabled]="file.editLabel === false"
      (changeValue)="changeValue($event, file, 'sendForBilling')"
      [value]="file.sendForBilling"
    ></lbca-input-boolean>
  </div>
</ng-template>
